<!-- eslint-disable -->
<template>
  <CommonPages id="disclaimer" :class="['disclaimer-page']" :titlePrefix="'Disclaimer'"
    :metaDescription="domainConfig?.['meta']?.des || 'Disclaimer and limitations of our website information'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Disclaimer</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                The information provided on {{ domainConfig?.siteName }} is for general
                informational purposes only. While we strive to ensure
                that the data we use is sourced from authoritative websites and is original, we make
                no representations or warranties of
                any kind, express or implied, about the completeness, accuracy, reliability,
                suitability, or availability of the
                information.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. General Information</h2>
              <p class="privacy-section__text">
                The content on this website is intended to provide general data and is for reference
                purposes only. It should not be
                considered as professional advice. Always seek the guidance of a qualified
                professional before making any decisions
                based on the information provided here.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. No Professional Advice</h2>
              <p class="privacy-section__text">
                This website does not offer any professional advice. Users should not rely solely on
                the information provided and should
                consult with appropriate professionals for specific advice tailored to their
                situation.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. Copyright and Infringement</h2>
              <p class="privacy-section__text">
                We respect the intellectual property rights of others. If you believe that any
                content on our website infringes upon
                your copyrights, please contact us immediately at {{ domainConfig?.IAMEMAIL }}. We
                will promptly address your concerns.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. External Links</h2>
              <p class="privacy-section__text">
                Through this website, you may be able to link to other websites which are not under
                the control of {{ domainConfig?.siteName }}.
                We have no control over the nature, content, and availability of those sites. The
                inclusion of any links does not
                necessarily imply a recommendation or endorse the views expressed within them.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Changes to This Disclaimer</h2>
              <p class="privacy-section__text">
                We may update this disclaimer from time to time. Any changes will be posted on this
                page and will take effect
                immediately. Please review it regularly to stay informed.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">Contact Us</h2>
              <p class="privacy-section__text">
                If you have any questions about this disclaimer, please contact us at
                {{ domainConfig?.IAMEMAIL }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Disclaimer',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(120);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #1a4048;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #1a4048;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #1a4048;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #1a4048;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #1a4048;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 